import {IGame, ISportEventContentBlock} from "@webng-types/write-model";
import {useSportEventSpec} from "../utils/useSportEventSpec";
import React from "react";

import {SportEventContentViewPlayers} from "./components/PlayerView";

interface SportEventContentViewProps {
  block: ISportEventContentBlock
  game: IGame
}

export function SportEventContentView({block, game}: SportEventContentViewProps) {
  const {sportstypeEventSpec} = useSportEventSpec(block.event_type)

  if (sportstypeEventSpec) {
    const slotIds = (sportstypeEventSpec.players ?? [])
      .map(p => p.id)
      .reduce((acc: string[], value) => acc.includes(value) ? acc : [...acc, value], [])
    // Players whose type the current spec no longer offers as a slot. A stored post is a record of
    // what was written; a later change to the sport's slots must not make its players disappear.
    const unlistedPlayers = block.players?.filter(p => !slotIds.includes(p.event_player_type ?? ""))
    return <div className="tik4-se__c">

        { (block.title || block.team) &&
          <div className="tik4-se__m">
            { block.title &&
              <div className="tik4-se__m__ti">
                { `${block.title} `}
              </div>
            }
            { block.team &&
              <div className="tik4-se__m__te">
                { block.team.name }
              </div>
            }
          </div>
        }
        {slotIds.map(id => {
            const eventPlayers = block.players?.filter(p => p.event_player_type === id)
            if(eventPlayers && eventPlayers.length > 0) {
              return <SportEventContentViewPlayers key={id} eventPlayers={eventPlayers} sportstypeEventSpec={sportstypeEventSpec} />
            } else {
              return null
            }
          })
        }
        {unlistedPlayers && unlistedPlayers.length > 0 &&
          <SportEventContentViewPlayers key="unlisted" eventPlayers={unlistedPlayers} sportstypeEventSpec={sportstypeEventSpec} />
        }
    </div>
    ;
  } else {
    return <React.Fragment/>
  }
}
